import { useId } from "react"
import { Eye } from "lucide-react"
import { Select } from "@/components/ui/field"
import { Notice } from "@/components/ui/page"
import { WalletRole } from "@/services/walletService"
import { useActivateWallet, useWallets, walletLabel } from "@/hooks/useWallets"

/** Seletor no topo do menu. Só aparece para quem participa de um grupo. */
export function WalletSwitcher() {
  const id = useId()
  const { data: wallets = [] } = useWallets()
  const activate = useActivateWallet()
  if (wallets.length < 2) return null

  const active = wallets.find((w) => w.isActive) ?? wallets[0]
  return (
    <div className="px-3 pt-4">
      <label htmlFor={id} className="px-2.5 mb-1.5 block text-[11px] font-medium uppercase tracking-[0.06em] text-muted-foreground">
        Carteira
      </label>
      <Select
        id={id}
        value={active.id}
        disabled={activate.isPending}
        onChange={(e) => activate.mutate(e.target.value)}
      >
        {wallets.map((w) => <option key={w.id} value={w.id}>{walletLabel(w)}</option>)}
      </Select>
    </div>
  )
}

/** Aviso fixo quando a carteira ativa não aceita alterações. */
export function WalletReadOnlyBanner() {
  const { data: wallets = [] } = useWallets()
  const active = wallets.find((w) => w.isActive)
  if (!active || active.canWrite) return null

  const reason = active.myRole === WalletRole.Viewer
    ? "Seu papel nela é de leitor."
    : "O plano do titular não cobre o grupo agora. Nada foi apagado, e a edição volta quando o plano for renovado."
  return (
    <div className="shrink-0 px-4 md:px-8 pt-3">
      <Notice tone="warning" icon={<Eye />}>
        A carteira {walletLabel(active)} está somente leitura. {reason}
      </Notice>
    </div>
  )
}
